"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

require("../styles/_video-details.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function formatDate(date) {
  if (!date) {
    return 'N/A';
  }

  return (0, _moment.default)(date, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('DD/MM/YYYY [at] h:MMa');
}

function DetailsTab(_ref) {
  var video = _ref.video;
  var videoId = video.videoId,
      creator = video.creator,
      createdAt = video.createdAt;
  return /*#__PURE__*/_react.default.createElement(_commonReact.HistoryTab, {
    resourceId: videoId
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "video-details-tab"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "video-details-tab__heading",
    heading3: true
  }, "Activity History"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading5: true
  }, "Created By"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "video-details-tab__createdby"
  }, "".concat((0, _getUserFullName.default)(creator), " on ").concat(formatDate(createdAt))), /*#__PURE__*/_react.default.createElement("hr", null)));
}

var _default = /*#__PURE__*/(0, _react.memo)(DetailsTab);

exports.default = _default;